export const SET_PMS_INTEGRATION = 'SET_PMS_INTEGRATION'
export const SET_PMS_INTEGRATION_IS_SAVING = 'SET_PMS_INTEGRATION_IS_SAVING'
export const SET_PMS_INTEGRATION_ERROR_CODE = 'SET_PMS_INTEGRATION_ERROR_CODE'
